import { createFileRoute } from "@tanstack/react-router";
import { Sidebar } from "@/components/sidebar";
import { VideoFeed } from "@/components/video-feed";
import { MobileNav } from "@/components/mobile-nav";
import { VideosProvider } from "@/hooks/useVideosContext";

export const Route = createFileRoute("/video/$id")({
  component: VideoPage,
});

function VideoPage() {
  const { id } = Route.useParams();

  return (
    <VideosProvider showVideoId={id}>
      <div className="flex h-dvh w-screen overflow-hidden">
        <Sidebar />
        <main className="flex-1 relative">
          <VideoFeed />
        </main>
        <MobileNav />
      </div>
    </VideosProvider>
  );
}
